import { Component, HostListener, Inject } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { LoadingService } from '../../services/loading.service'
import { RestrictedProductAuthorizationService } from '../../../core/restricted-product/services/restricted-product-authorization.service'
import { AccountAuthorization } from '../../shared.interfaces'
import moment from 'moment'
import { Router } from '@angular/router'

@Component({
    selector: 'app-action-result-dialog',
    templateUrl: './action-result-dialog.component.html',
    styleUrls: ['./action-result-dialog.component.scss'],
    standalone: false
})
export class ActionResultDialogComponent {
  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<ActionResultDialogComponent>,
    private loadingService: LoadingService,
    private router: Router,
    private restrictedProductAuthorizationService: RestrictedProductAuthorizationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  /*istanbul ignore next*/
  downloadAuthorization(authorization: AccountAuthorization) {
    this.loadingService.set({ message: 'Downloading authorization', value: true })
    this.restrictedProductAuthorizationService
      .getPdf(authorization.restrictedProductAccountId, authorization.id)
      .subscribe(
        (blob) => {
          this.loadingService.set({ message: null, value: false })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `Authorization-${this.data.account.name}-${moment().format('MM-DD-YYYY')}.pdf`
          document.body.appendChild(link)
          link.click()
          link.remove()
        },
        (_) => this.setError()
      )
  }

  /*istanbul ignore next*/
  setError() {
    this.loadingService.set({ message: null, value: false })
    this.router.navigate(['/restricted-product/error'], { skipLocationChange: true })
  }

  close(): void {
    this.dialogRef.close()
  }
}
